<template>
  <div>
    <v-row no-gutters class="form-group" v-if="!noLabel">
      <span v-if="label !== ''" class="item-label">{{ label }}</span>
      <span v-else class="item-label" style="color:white" />
      <label class="form-group-label">
        <span v-if="required && !requiredMarkHidden" class="mandatory">必須</span>
      </label>
    </v-row>
    <v-row no-gutters class="py-0 range-style" :style="'margin-top: 1px; background-color:' + (required && !readonly ? '#FFEDEE;' : 'white;') + (readonly ? 'border-bottom: 1px solid #1F2B38' : 'border: 1px solid #CDD6DD; border-radius:5px;')">
      <v-col class="py-0 d-flex" :cols="12">
        <div style="display: inline-block;width:40%">
          <dd-month-box-inside
            v-on="computedListeners"
            v-bind="computedProps"
            v-model="fromMonth"
            label=""
            :readonly="readonly"
            :required="required || requiredFrom"
            :placeholder="phtext"
            :tabindex="readonly ? -1 : 0"
            @input="setFromMonth"
            @click="hideCalendar"
          />
        </div>
        <div class="pl-1 pr-0 pt-1" style="display: inline-block;">～</div>
        <div class="px-0" style="display: inline-block;width:40%">
          <dd-month-box-inside
            v-on="computedListeners"
            v-bind="computedProps"
            v-model="toMonth"
            label=""
            :readonly="readonly"
            :required="required || requiredTo"
            :placeholder="phtext"
            :tabindex="readonly ? -1 : 0"
            @input="setToMonth"
            @click="hideCalendar"
          />
        </div>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { VTextField } from 'vuetify/lib'
import inputMixin from '@/mixins/inputMixins'

import DdMonthBoxInside from '@/components/DdMonthBoxInside'

/**
 * @file DDv2用日付入力
 * @namespace components
 */

/**
 * @vue-prop {Boolean} [required=false] - 必須有無
 * @vue-prop {String} [max='']- 許容最大値(デフォルト:2999/12/31)
 * @vue-prop {String} [min=''] - 許容最小値(デフォルト:2000/01/01)
 * @vue-prop {String} [errorMessages=''] - エラーメッセージ
 * @see https://vuetifyjs.com/ja/api/v-text-field/
 * @example
  <dd-date-box
    label="適用開始日"
    v-model="dateValue"
    max="2099/12/31"
    min="2000/01/01"/>
 */
export default {
  name: 'DdMonthRangeBox',
  extends: VTextField,
  components: {
    DdMonthBoxInside
  },
  mixins: [inputMixin],
  props: {
    /**
     * ラベル
     */
    label: String,
    /*
     * From日付
     */
    fromMonth: {
      type: String,
      default: ''
    },
    /**
     * To日付
     */
    toMonth: {
      type: String,
      default: ''
    },
    /**
     * 必須指定
     */
    required: {
      type: Boolean,
      default: false
    },
    /**
     * 必須指定(FROMのみ)
     * Required優先
     */
    requiredFrom: {
      type: Boolean,
      default: false
    },
    /**
     * 必須指定(TOのみ)
     * Required優先
     */
    requiredTo: {
      type: Boolean,
      default: false
    },
    /**
     * 入力可能最大値
     */
    max: String,
    /**
     * 入力可能最小値
     */
    min: String,
    /**
     * 表示エラーメッセージ
     */
    errorMessages: String,
    /**
     * タイトル表示
     */
    no_title: {
      type: Boolean,
      default: true
    },
    /**
     * ツールチップテキスト
     */
    tooltipText: {
      type: String,
      default: ''
    },
    /**
     * ツールチップ表示要否
     */
    enableToolTip: {
      type: Boolean,
      default: true
    },
    /**
     * ツールチップ表示位置（左）
     */
    tooltipLeft: {
      type: Boolean,
      default: false
    },
    /**
     * ツールチップ表示位置（上）
     */
    tooltipTop: {
      type: Boolean,
      default: false
    },
    /**
     * ツールチップ表示位置（右）
     */
    tooltipRight: {
      type: Boolean,
      default: false
    },
    /**
     * ツールチップ表示位置（下）
     */
    tooltipBottom: {
      type: Boolean,
      default: false
    },
    /**
     * ラベル不要
     */
    noLabel: {
      type: Boolean,
      default: false
    },
    /**
     * 必須マーク非表示
     */
    requiredMarkHidden: {
      type: Boolean,
      default: false
    },
    /**
     * defaultPickerType
     * 01:期間,02:From,03:To
     */
    defaultPickerType: {
      type: String,
      default: ''
    },
    /**
     * 使用モード
     * ---------------------------------------------
     * 選択時のラジオボタンの表記が変わります。
     * 未指定時は検索用
     * ---------------------------------------------
     */
    useMode: {
      type: String,
      default: 'search'
    }
  },
  data: () => ({
    phtext: '',
    hasFocus: false,
    invalidMessage: '',
    innerValue: '',
    isShowCalendar: false,
    rangeDate: [null, null],
    defaultMax: '2999/12/31',
    defaultMin: '2000/01/01',
    pickerType: '00',
    pickerCloseFlg: false,
    selectedFrom: null,
    selectedTo: null,
    selectedMode: 0,
    calendarRangeDate: { start: null, end: null },
    modelConfig: {
      type: 'string',
      mask: 'YYYY-MM-DD'
    },
    selectedSupport: null,
    pickerActionsForSearch: [
      { value: '00', label: '範囲を指定' },
      { value: '01', label: '指定日以降を対象' },
      { value: '02', label: '指定日以前を対象' }
    ],
    pickerActionsForInput: [
      { value: '00', label: '範囲を指定' },
      { value: '01', label: '開始日のみ指定' },
      { value: '02', label: '終了日のみ指定' }
    ],
    supportActions: [
      { value: 'today', label: '今日', usePicker: null },
      { value: 'yesterday', label: '昨日', usePicker: null },
      { value: 'last7Days', label: '過去7日間(今日を含まない)', usePicker: '00' },
      { value: 'thisMonth', label: '今月', usePicker: '00' },
      { value: 'thisMonthWithoutToday', label: '今月(前日まで)', usePicker: '00' },
      { value: 'prevMonth', label: '先月', usePicker: '00' }
    ]
  }),
  created () {
    if (this.defaultPickerType !== '') this.pickerType = this.defaultPickerType
  },
  mounted () {
  },
  computed: {
    computedProps () {
      return {
        ...this.$props
      }
    },
    computedListeners () {
      return {
        ...this.$listeners
      }
    },
    calendarMax () {
      if (this.max) {
        return this.max.split('/').join('-')
      }
      return undefined
    },
    calendarMin () {
      if (this.min) {
        return this.min.split('/').join('-')
      }
      return undefined
    },
    isRange () {
      return this.pickerType === '00'
    }
  },
  methods: {
    hideCalendar: function (e) {
      this.isShowCalendar = false
    },
    setFromMonth: function (e) {
      console.log('setFromMonth :', e)
      this.$emit('update:fromMonth', e)
    },
    setToMonth: function (e) {
      console.log('setToMonth :', e)
      this.$emit('update:toMonth', e)
    },
    setRangeDate: function (from, to) {
      const tmpRangeDate = {
        start: from,
        end: to
      }
      this.calendarRangeDate = Object.assign({}, tmpRangeDate)
      this.selectedFrom = from
      this.selectedTo = to
      this.selectedMode = 0
    },
    handleShow () {
      this.$refs.calendar.adjustPageRange()
    }
  }
}
</script>
<style scoped>
.range-style {
  height:32px !important;
  overflow: hidden;
}
.v-picker.v-card.v-picker--date {
  position: absolute;
  z-index: 500;
}
.mdi-calendar::before {
  color: #2196F3;
}
.v-menu__content.theme--light {
  width: 760px !important;
  height: 368px !important;
  background-color: #FFF;
}
.radio-inline__input {
    clip: rect(1px, 1px, 1px, 1px);
    position: absolute !important;
}
.radio-inline__label {
    display: inline-block;
    padding: 0.5rem 1rem;
    margin-right: 18px;
    border-radius: 3px;
    transition: all .2s;
}
.radio-inline__input:checked + .radio-inline__label {
    background: #B54A4A;
    color: #fff;
    text-shadow: 0 0 1px rgba(0,0,0,.7);
}
.radio-inline__input:focus + .radio-inline__label {
    outline-color: #4D90FE;
    outline-offset: -2px;
    outline-style: auto;
    outline-width: 5px;
}
.input-info {
  font-size:small;
  font-weight:bold;
}
/** 指定方法用 */
::v-deep .v-input--selection-controls {
    margin-top: 0px !important;
    padding-top: 1px !important;
}
::v-deep .v-radio>.v-label{
    padding-top: 1px !important;
    font-size:0.625rem !important;
    font-weight: bold !important;
}
/** 入力補助用 */
.support {
  margin: 1px;
  width: 230px;
  background: #f8f8f8;
  color: #1F2B38;
  padding: 5px 10px;
  border-radius: 3px;
  display: inline-block;
  cursor: pointer;
}
input[type="radio"] {
  display: none;
}
input[name="support"]:hover + label {
  background-color: #e0e8ff;
  font-weight: bold;
}
input[name="support"]:checked + label {
  background-color: #00ffff;
  font-weight: bold;
}
</style>
